import { LAYOUT } from '../../constant'

const user = {
  path: '/collage',
  redirect: '/collage/index',
  component: LAYOUT,
  meta: {
    title: 'Test',
    orderNo: 1,
    hideChildrenInMenu: true
  },
  children: [
    {
      path: 'index',
      name: 'Collage',
      component: () => import('@/views/Test.vue')
    }
  ]
}

export default user
